var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { c as _c } from "react/compiler-runtime";
import { BBookableTypeEnum } from '@/types/backend';
import EntityCardDetailContentTemplate from '../components/EntityCardDetailContentTemplate';
const ExperienceCardDetailContent = t0 => {
    const $ = _c(13);
    let experience;
    let props;
    if ($[0] !== t0) {
        ({ experience } = t0, props = __rest(t0, ["experience"]));
        $[0] = t0;
        $[1] = experience;
        $[2] = props;
    }
    else {
        experience = $[1];
        props = $[2];
    }
    const mealConfiguration = experience.type === BBookableTypeEnum.Meal && experience.configuration || undefined;
    const description = `${experience.descriptionShort}...`;
    let t1;
    if ($[3] !== description || $[4] !== experience.callPrice || $[5] !== experience.canBeGifted || $[6] !== experience.identifier || $[7] !== experience.informations || $[8] !== experience.rating || $[9] !== experience.type || $[10] !== mealConfiguration || $[11] !== props) {
        t1 = <EntityCardDetailContentTemplate calculatedPrice={null} callPrice={experience.callPrice} description={description} entityType={experience.type} entityId={experience.identifier} information={experience.informations} mealConfiguration={mealConfiguration} rating={experience.rating} canBeGifted={experience.canBeGifted} {...props}/>;
        $[3] = description;
        $[4] = experience.callPrice;
        $[5] = experience.canBeGifted;
        $[6] = experience.identifier;
        $[7] = experience.informations;
        $[8] = experience.rating;
        $[9] = experience.type;
        $[10] = mealConfiguration;
        $[11] = props;
        $[12] = t1;
    }
    else {
        t1 = $[12];
    }
    return t1;
};
export default ExperienceCardDetailContent;
